module.exports = __webpack_public_path__ + "img/bom-layer-icon.22199e80.svg";